export default __webpack_public_path__ + "static/media/aleo-v4-latin-regular.26b411c5.woff2";